<template>
<div>
    <Box @close="close(false)" :width="'800px'">
        <template #top>Nueva Transferencia: Compra Externa</template>
        <template #center>
            <div class="nj-panel">
                <div class="nj-panel-content">
                    <div class="nj-grid">
                        <InputSelect label="Almacen destrino" v-model="transferencia_items.alm_destino" id="te-almacenes-destino" :source="almacenes" itemKey="alm_id" itemValue="alm_id"
                            :filterFunction="filterAlmacen" :labelFunction="labelAlmacen">
                            <template #default="data">
                                {{ labelAlmacen(data.item) }}
                            </template>
                        </InputSelect>
                        <InputDate label="Fecha de llegada" v-model="transferencia_items.tfi_fecha_estimada_llegada_date"></InputDate>
                    </div>
                    <br>
                    <SearchBox label="Item" id="ta-items" itemKey="prv_id" :source="productos" :labelFunction="(item) => item.prv_nombre" :searchFunction="buscarItems" @selectItem="agregarProducto">
                        <template #default="data">
                            <div class="nj-grid">
                                <span>{{ `${data.item.prv_nombre}` }}</span>
                            </div>
                        </template>
                    </SearchBox>
                    <br>
                    <b-table :data="transferencia_items.lista_transferencia_items_detalle" :sort-icon="sortIcon" :sort-icon-size="sortIconSize">
                        <template slot-scope="props">
                            <b-table-column label="Producto" header-class="is-info">{{ props.row.prv_nombre }}</b-table-column>
                            <b-table-column label="Cantidad" header-class="is-info" style="width: 100px;">
                                <input type="text" class="nj-text" v-model="props.row.tid_cantidad">
                            </b-table-column>
                            <b-table-column label="Opciones" header-class="is-info" style="width: 70px;">
                                <button class="nj-button icon c-red" title="Retirar" @click="retirarProducto(props.row.prv_id)"><i class="mdi mdi-delete"></i></button>
                            </b-table-column>
                        </template>
                    </b-table>
                </div>
            </div>
        </template>
        <template #bottom>
            <button class="nj-button c-green" @click="registrar()"><i class="mdi mdi-content-save"></i>Registrar</button>
        </template>
    </Box>
</div>
</template>

<script>
import { Box, Button, InputDate, InputSelect, InputText, SearchBox } from "../../modules/components"
import { ProductoService, ResponseStatus, TransferenciaItemsService, UsuarioService } from "../../rest"
import { Acceso, Data, DateTime, Validator } from "../../util"
import Toast from "../../util/toast"

export default {
    name: "TransferenciaCompraExterna",
    components: {
        Box,
        Button,
        InputSelect,
        SearchBox,
        InputText,
        InputDate,
    },
    data() {
        return {
            transferencia_items: {
                tfi_usu_registrador: UsuarioService.getUsuario().usu_id,
                tfi_tipo: 3, // transferencia: compra externa
                tfi_fecha_estimada_llegada: null,
                tfi_fecha_estimada_llegada_date: null,
                alm_destino: null,
                lista_transferencia_items_detalle: []
            },
            productos: [],
            almacenes: [],
            prv_nombre: null,
            alm_nombre: null,
            sortIcon: "arrow-up",
            sortIconSize: "is-small",
        }
    },
    methods: {
        registrar() {
            if (Validator.start(
                this.transferencia_items.alm_destino,
                this.transferencia_items.lista_transferencia_items_detalle,
                this.transferencia_items.tfi_fecha_estimada_llegada_date,
            )) {
                TransferenciaItemsService.registrar(this.transferencia_items).then(
                    response => {
                        Toast.success(response.message)
                        this.close(true)
                    },
                    error => {
                        Toast.error(error)
                        console.error(`error: `, error)
                    }
                )
            }
            else {
                Toast.warn("Falta ingresar algunos datos para registrar la transferencia")
            }
        },
        close(buscar) {
            this.$emit("close", {
                interfaz: "TransferenciaCompraExterna",
                activar: false,
                buscar
            })
        },
        filterAlmacen(items, param) {
            if (param != null && param != "") {
                return items.filter(item => `${item.pry_nombre} | ${item.alm_nombre}`.toLowerCase().includes(param.toLowerCase()))
            }
            else {
                return items
            }
        },
        labelAlmacen(almacen) {
            return `${almacen.pry_nombre} | ${almacen.alm_nombre} ${almacen.alm_tipo == 0 ? "*" : ""}`
        },
        buscarItems(prv_nombre) {
            const request = {
                producto: {
                    prv_nombre,
                }
            }
            ProductoService
                .buscarRapido(request)
                .then(response => {
                    if (ResponseStatus.isSuccess(response)) {
                        this.productos = response.data
                    }
                    else {
                        Toast.warn(response.message)
                    }
                }).catch(error => {
                    Toast.error(error)

                })
        },
        agregarProducto(item) {
            const prod = this.transferencia_items.lista_transferencia_items_detalle.find(i => i.prv_id == item.prv_id)
            if (!prod) {
                this.transferencia_items.lista_transferencia_items_detalle.push({
                    prv_id: item.prv_id,
                    prv_nombre: item.prv_nombre,
                    tid_cantidad: 1,
                })
            }
            else {
                Toast.warn("El producto ya ha sido agregado")
            }
            this.productos = []
        },
        retirarProducto(prv_id) {
            this.transferencia_items.lista_transferencia_items_detalle = this.transferencia_items.lista_transferencia_items_detalle.filter(i => i.prv_id != prv_id)
        },
        seleccionarAlmacen(item) {
            this.transferencia_items.alm_destino = item.alm_id
            this.alm_nombre = item.alm_nombre
        },

    },
    mounted() {
        this.transferencia_items.tfi_fecha_estimada_llegada_date = DateTime.todayString()
        this.almacenes = Data.getAlmacenes()
    }
}
</script>

<style scoped></style>